import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { closeDrawerMenu } from '../../../modules/ui/store/ui-slice';
import { useBreakpoint } from '../../../shared/hooks/use-breakpoint';
import { MenuItem } from './use-menu-items';

const UseNavigateHeaderLinks = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const screens = useBreakpoint();

  return (menuItem: MenuItem) => {
    if (!screens.xl) {
      dispatch(closeDrawerMenu());
    }
    navigate(menuItem.path);
  };
};

export default UseNavigateHeaderLinks;
